import {Link} from 'react-router-dom';
import React from 'react';

export const MainMenus = () => (
  <ul className="main-menus">
    <li className="product">
      <Link to="/products/guide">상품안내 &middot; 구매</Link>
    </li>
    <li className="ip" data-qa="ipManagementIndex">
      <Link to="/my-pc-bang/management/ip-management">IP관리</Link>
    </li>
    <li className="usage" data-qa="usageStatusIndex">
      <Link to="/my-pc-bang/usage-status/payment-and-billing">사용내역</Link>
    </li>
    <li className="tournament">
      <Link to="/news/tournament-kit">대회지원요청</Link>
    </li>
    <li className="userinfo">
      <Link to="/my-pc-bang/management/user-info-modification">회원정보관리</Link>
    </li>
    <li className="inquiry">
      <Link to="/customer/inquiries">1:1 문의</Link>
    </li>
  </ul>
);
